import { h } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { i18n } from 'i18n/i18n'

import { ExchangeDirection } from 'models/exchange-transfer-calculate'

import SingleOption from './single-option'

interface CalculatorDirectionSelectProps {
  options: ExchangeDirection[]
  direction: ExchangeDirection
  setDirection: (direction: ExchangeDirection) => void
  isDarkMode?: boolean
}

const CalculatorDirectionSelect = ({
  options,
  direction,
  setDirection,
  isDarkMode,
}: CalculatorDirectionSelectProps) => {
  const [isSelectVisible, setSelectVisibility] = useState(false)

  const toggleSelectVisibility = (): void => {
    setSelectVisibility((prev) => !prev)
  }

  const disableOptionsList = (e: MouseEvent): void => {
    const target = e.target as HTMLElement
    const isInside = target.closest('[data-direction-holder]')
    if (isSelectVisible && !isInside) {
      setSelectVisibility(false)
    }
  }

  useEffect(() => {
    const listener = (e: MouseEvent) => disableOptionsList(e)
    const main = document.querySelector<HTMLDivElement>('.calc-widget__main')
    main?.addEventListener('click', listener)
    return () => main?.removeEventListener('click', listener)
  }, [isSelectVisible])

  const translateOption = (direction: ExchangeDirection): string =>
    direction === 'forward' ? String(i18n('widgetCalculator.buySelect')) : String(i18n('widgetCalculator.sellSelect'))

  return (
    <div
      className="calc-widget__options-holder"
      data-direction-holder
    >
      <div
        className="calc-widget__select is-width"
        aria-expanded={isSelectVisible}
        role="button"
        tabIndex={0}
        onClick={toggleSelectVisibility}
        onKeyDown={(e) => e.key === 'Enter' && toggleSelectVisibility()}
        data-value={translateOption(direction)}
        data-calculator-direction
      >
        <p>{translateOption(direction)}</p>
        <span className={`calc-widget__select-chevron ${isDarkMode ? 'is-dark-mode' : ''}`} />
      </div>

      {isSelectVisible && (
        <div
          className="calc-widget__options-list is-width"
          onClick={toggleSelectVisibility}
        >
          {options.map((option) => (
            <SingleOption
              key={option}
              option={option}
              optionName={translateOption(option)}
              handleSetClickedOption={setDirection}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default CalculatorDirectionSelect
